import { render, staticRenderFns } from "./CdkNavigation.vue?vue&type=template&id=6ac12a0c&scoped=true&"
import script from "./CdkNavigation.vue?vue&type=script&lang=ts&"
export * from "./CdkNavigation.vue?vue&type=script&lang=ts&"
import style0 from "./CdkNavigation.vue?vue&type=style&index=0&id=6ac12a0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac12a0c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
installComponents(component, {VNavigationDrawer})
